import styled from 'styled-components';

import { bodySemibold } from 'styles/mixins/fonts';

// "Change due: $X" under the check amount when the check is written for more
// than the amount due.
export const ChangeDue = styled.p`
  ${bodySemibold};
  margin: 8px 0 0;
`;
